import type { IScrollColumnConfig } from '~/modules/heatmap/hooks';

import { Box, InlineGrid, BlockStack, Text } from '@shopify/polaris';
import { GSkeletonDisplayText } from '~/presentation/common';
import { GDiv, GTooltipCard } from '~/presentation/ui';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import { SPACING_INSET } from '../Sidebar';

export const ScrollRankSkeleton: React.FC<{ columns: IScrollColumnConfig[] }> = ({ columns }) => {
  const SKELETON_ROWS = 3;

  return (
    <>
      <Box position="sticky" insetBlockStart="0" zIndex="10" background="bg-fill">
        <Box paddingInline="150" paddingBlock="500">
          <InlineGrid columns={3} gap="200" alignItems="center">
            {columns.map((col) => (
              <GTooltipCard
                key={col.label}
                wrapper="span"
                alignment={col.labelAlignment ?? 'start'}
                tooltip={col.tooltip}
                isHideBorder
                textDecoration="underline"
              >
                <Text
                  as="span"
                  variant="bodySm"
                  fontWeight="medium"
                  alignment={col.labelAlignment ?? 'start'}
                  key={col.label}
                >
                  {col.label}
                </Text>
              </GTooltipCard>
            ))}
          </InlineGrid>
        </Box>
        <div className="gx-hm-divider" />
      </Box>

      <BlockStack gap="0">
        {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
          <Fragment key={index}>
            <Box paddingInline="150" paddingBlock="500" background="bg-fill">
              <InlineGrid columns={3} gap="200">
                {columns.map((col) => (
                  <GDiv key={col.label} className="text-[--p-color-text-info-secondary]">
                    <GSkeletonDisplayText height="8px" />
                  </GDiv>
                ))}
              </InlineGrid>
            </Box>
            <div className="gx-hm-divider" />
          </Fragment>
        ))}
      </BlockStack>
    </>
  );
};

export const ScrollRankEmpty: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box padding={SPACING_INSET}>
      <Text as="p" variant="bodyMd" tone="subdued">
        {t('No scroll data available')}
      </Text>
    </Box>
  );
};
